import { Grid } from '@mui/material';
import { formatters } from '@utils/formattersV2';
import { SplineChartWithHeader } from '../../../../../../components/Summary/SplineChartWithHeader';
import { Lci3Report } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';

type VisitChartsProps = {
  allReports: Lci3Report[];
};

const overallStatsToSeriesData = (
  allReports: Lci3Report[],
  field: keyof Pick<
    Lci3Report['visitMetrics'],
    'incrementalLift' | 'incrementalVisits' | 'impressions' | 'uniqueUsers'
  >
) =>
  allReports
    .map(report => ({
      date: report.reportDate,
      value: report.visitMetrics[field] ?? 0,
    }))
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date));

export const VisitCharts = (props: VisitChartsProps) => {
  const incrementalLiftData = overallStatsToSeriesData(
    props.allReports,
    'incrementalLift'
  );
  const incrementalVisitsData = overallStatsToSeriesData(
    props.allReports,
    'incrementalVisits'
  );
  const impressionsData = overallStatsToSeriesData(
    props.allReports,
    'impressions'
  );
  const usersData = overallStatsToSeriesData(props.allReports, 'uniqueUsers');

  return (
    <Grid container>
      <Grid
        data-testid="incremental-visit-lift-chart"
        size={{
          lg: 6,
          xs: 12,
        }}
      >
        <SplineChartWithHeader
          title="Incremental Visit Lift"
          confidenceLevel={
            props.allReports.at(-1)?.visitMetrics.confidenceLevel ?? undefined
          }
          data={incrementalLiftData}
          formatter={formatters.lift}
          yAxisLabelFormatter={formatters.percentage}
          differenceType="lift"
        />
      </Grid>
      <Grid
        data-testid="incremental-visits-chart"
        size={{
          lg: 6,
          xs: 12,
        }}
      >
        <SplineChartWithHeader
          title="Incremental Visits"
          data={incrementalVisitsData}
          formatter={value => formatters.visits(value, { full: true })}
          yAxisLabelFormatter={formatters.number}
          differenceType="standard"
        />
      </Grid>
      <Grid
        data-testid="impressions-chart"
        size={{
          lg: 6,
          xs: 12,
        }}
      >
        <SplineChartWithHeader
          title="Impressions"
          data={impressionsData}
          formatter={value => formatters.impressions(value, { full: true })}
          yAxisLabelFormatter={formatters.number}
          differenceType="standard"
        />
      </Grid>
      <Grid
        data-testid="unique-users-chart"
        size={{
          lg: 6,
          xs: 12,
        }}
      >
        <SplineChartWithHeader
          title="Unique Users"
          data={usersData}
          formatter={value => formatters.users(value, { full: true })}
          yAxisLabelFormatter={formatters.number}
          differenceType="standard"
        />
      </Grid>
    </Grid>
  );
};
